$.fn.filterStories = function(result_selector) {
  let self = this

  $(self).find('.story-header__categories__item').click(function() {
    if ($(this).attr('data-filter') == 'all') {
      var filter = '.grid__item'
    } else {
      var filter = '.category--' + $(this).attr('data-filter')
    }
    self.find('.story-header__categories__selected').html($(this).html())
    $(self).find('.story-header__categories__item').removeClass('--selected')
    $(this).addClass('--selected')
    $(result_selector).find('.grid__item').addClass('--hide');
    $(result_selector).find(filter).removeClass('--hide').addClass('slide-in--visible');
  });

  return function() {
    return self
  }()
};
